import { Controller } from "@hotwired/stimulus";

// 運用期間（予定）の値を運用期間（実績）の入力欄へコピーする
class CopyOperationPeriodController extends Controller {
  static targets = ['estimatedStart', 'estimatedEnd', 'actualStart', 'actualEnd']

  copy() {
    this.setValue(this.actualStartTarget, this.estimatedStartTarget.value);
    this.setValue(this.actualEndTarget, this.estimatedEndTarget.value);
  }

  // value への代入では change が発火しない (DOM 仕様上、ユーザー操作でのみ発火する)。
  // そのままでは入力欄に同居する holiday-datepicker が値の変更に気づけず、
  // 入力欄の表示とカレンダーの選択日がずれてしまう。
  // 明示的に発火させて追従させる。
  setValue(input, value) {
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

// Registered in admin.js
export { CopyOperationPeriodController };
